export const environment = {
  production: false,
  env: 'Testing',
  ApiUrl: 'https://dmxhthapitest.clavisco.com/',
};
